
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import './make-built-in.js';
import './object-define-property.js';
import { __exports as objectDefineProperty } from '../../../_virtual/object-define-property.js';
import { m as makeBuiltIn$1 } from '../../../_virtual/make-built-in.js';

var makeBuiltIn = makeBuiltIn$1.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

export { defineBuiltInAccessor as default };
//# sourceMappingURL=define-built-in-accessor.js.map
